/**
* Nom : trialEdit.js
* Description : Ce fichier contient la définition de la page trialEdit 
*               Cette page fourni un formulaire pour mettre à jour les informations d'un essai
* Date de création : 30 septembre 2024
*/

/* CSS et assets */
// None

/* Bibliothèques et composants */
import { TabRD } from 'package_ui_ihm/dist'
import { Container } from 'package_ui_ihm/dist'
import { BackPage } from 'package_ui_ihm/dist'
import { SelectForm} from 'package_ui_ihm/dist'
import { InputForm } from 'package_ui_ihm/dist'

/* Hook */
import { useState, useEffect } from 'react'
import { useBlocker } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useData } from 'package_ui_ihm/dist';
import { useNavigate } from 'react-router-dom'
import { useScreenWidth } from 'package_ui_ihm/dist'


/**
* TrialEdit : affiche une page avec un formulaire pour mettre à jour les informations d'un essai
*                 un lien permet de revenir sur la page qui contient les informations détaillées de l'essai
*
* Type : page 
*
* Parametres : 
*  None
*/
function TrialEdit() {

    //Define useParam
    const { id } = useParams()


    // Define useState hooks
    const [name, setName] = useState('');
    const [reference, setReference] = useState('');
    const [selectedTarget, setSelectedTarget] = useState(0);
    const [selectedTreatmentType, setSelectedTreatmentType] = useState(0);
    const [nbRecurrence, setNbRecurrence] = useState(0);
    const [note, setNote] = useState('');
    const [year, setYear] = useState('');
    const [selectedMonth, setSelectedMonth] = useState(0);
    const [selectedValstatus, setSelectedValstatus] = useState(0);
    const [selectedProduct, setSelectedProduct] = useState(0);
    const [comments, setComments] = useState('');
    const [keywords, setKeywords] = useState('');
    const [targets, setTargets] = useState([])
    const [treatmentTypes, setTreatmentTypes] = useState([])
    const [products, setProducts] = useState([])
    const [oldTrial, setOldTrial] = useState(null)
    const [statusOldTrial, setStatusOldTrial] = useState(null)
    const [statusNewTrial, setStatusNewTrial] = useState(null)
    const [nameError, setNameError] = useState(false);
    const [referenceError, setReferenceError] = useState(false);
    const [targetError, setTargetError] = useState(false);
    const [treatmentTypeError, setTreatmentTypeError] = useState(false);
    const [nbRecurrenceError, setNbRecurrenceError] = useState(false);
    const [yearError, setYearError] = useState(false);
    const [monthError, setMonthError] = useState(false);
    const [productError, setProductError] = useState(false);
    const [versions, setVersions] = useState([{id: 1, name: '1'}])
    const [selectedVersion, setSelectedVersion] = useState(0);
    const [versionError, setVersionError] = useState(false);
    const [isDataLoading, setDataLoading] = useState(false)
    const [oldReference, setOldReference] = useState('');
    const [oldSelectedTarget, setOldSelectedTarget] = useState(0);
    const [oldSelectedTreatmentType, setOldSelectedTreatmentType] = useState(0);
    const [oldYear, setOldYear] = useState('');
    const [oldSelectedMonth, setOldSelectedMonth] = useState(0);
    const [oldSelectedProduct, setOldSelectedProduct] = useState(0);
    const [oldSelectedVersion, setOldSelectedVersion] = useState(0);
    const [formSubmit, setFormSubmit] = useState(false);
    const [skipPrompt, setSkipPrompt] = useState(false);


    // Define useContext hooks
    const { authStatus, authToken } = useAuth();
    const { path } = useApi();
    const { months } = useData();

    const navigate = useNavigate();


    // Define useBlocker hooks
    const shouldBlock = 
        ((selectedTreatmentType !== oldSelectedTreatmentType) || 
        (selectedTarget !== oldSelectedTarget) ||
        (year !== oldYear) ||
        (selectedMonth !== oldSelectedMonth) ||
        (reference !== oldReference) ||
        (selectedProduct !== oldSelectedProduct) ||
        (selectedVersion !== oldSelectedVersion)) && 
        (skipPrompt === false);
    const blocker = useBlocker(shouldBlock);


    // Define useScreenWidth hooks
    const screenWidth = useScreenWidth();


    // Define functions
    async function sendData(name, reference, target_id, treatment_type_id, nb_recurrence, note, year, month_id, valid_status_id, comments, keywords, product_id, product_version) {
        // Token
        const token = "Bearer " + authToken
        // Création du Form Data
        let form_data = new FormData();
        form_data.append("name", name);
        form_data.append("reference", reference);
        form_data.append("target_id", target_id);
        form_data.append("treatment_type_id", Number(treatment_type_id));
        form_data.append("nb_recurrence", Number(nb_recurrence));
        form_data.append("year", Number(year));
        form_data.append("month_id", month_id);
        form_data.append("validation_status_id", valid_status_id);
        form_data.append("product_id", product_id);
        form_data.append("product_version", product_version);
        if(note) {
            form_data.append("note_intervalle_recurrence", note);
        }
        if(comments) {
            form_data.append("comments", comments);
        }
        if(keywords) {
            form_data.append("keywords", keywords);
        }
        // Update trial 
        const response = await fetch(path + "/api/bo-tral/" + id + "/", 
            {
                method: 'PATCH',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                    Authorization: token,
                },
                body: form_data
            }
        )
        //const data = await response.json();
        setStatusNewTrial(response["status"])
        //setWarningTreatment(data["detail"])
        setFormSubmit(false)
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        setSkipPrompt(true);
        if(name === null || name === ''){
            setNameError(true)
        }
        else
        {   
            setNameError(false)
        }
        if(reference === null || reference === '' || reference.length > 5){
            setReferenceError(true)
        }
        else
        {   
            setReferenceError(false)
        }
        if(selectedTarget === 0 || selectedTarget === '0'){
            setTargetError(true)
        }
        else
        {   
            setTargetError(false)
        }
        if(selectedTreatmentType === 0 || selectedTreatmentType === '0'){
            setTreatmentTypeError(true)
        }
        else
        {   
            setTreatmentTypeError(false)
        }
        if(nbRecurrence === 0 || nbRecurrence === '0'){
            setNbRecurrenceError(true)
        }
        else
        {   
            setNbRecurrenceError(false)
        }
        if(year === null || year === ''){
            setYearError(true)
        }
        else
        {   
            setYearError(false)
        }
        if(selectedMonth === 0 || selectedMonth === '0'){
            setMonthError(true)
        }
        else
        {   
            setMonthError(false)
        }
        if(selectedProduct === 0 || selectedProduct === '0'){
            setProductError(true)
        }
        else
        {   
            setProductError(false)
        }
        if(selectedVersion === 0 || selectedVersion === '0'){
            setVersionError(true)
        }
        else
        {   
            setVersionError(false)
        }
        setFormSubmit(true)
    };

    async function retrieveData() {
        // Token
        const token = "Bearer " + authToken
        // Headers
        const headers = {
            accept: 'application/json',
            Authorization: token,
        }
        // Requests in parallel to win time 
        const [resTarget, resTreatmentType, resProduct, resTrial] = await Promise.all([
            // Target
            fetch(path + "/api/bo-taet/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Treatment types
            fetch(path + "/api/bo-trty/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Product
            fetch(path + "/api/eq-prct/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Trial details
            fetch(path + "/api/bo-tral/" + id + "/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
        ])
        // Responses in parallel to win time
        const [dataTarget, dataTreatmentType, dataProduct, dataTrial] = await Promise.all([
            resTarget.json(),
            resTreatmentType.json(),
            resProduct.json(),
            resTrial.json(),
        ])
        // Set variables
        setTargets(dataTarget["results"])
        setTreatmentTypes(dataTreatmentType["results"])
        setProducts(dataProduct["results"])
        setStatusOldTrial(resTrial["status"])
        setOldTrial(dataTrial)
        setName(dataTrial["name"])
        setReference(dataTrial["reference"])
        setSelectedTarget(dataTrial["target"]["id"])
        setSelectedTreatmentType(dataTrial["treatment_type"]["id"])
        setNbRecurrence(dataTrial["nb_recurrence"])
        setNote(dataTrial["note_intervalle_recurrence"])
        setYear(dataTrial["year"])
        setSelectedMonth(dataTrial["month"]["id"])
        setSelectedValstatus(dataTrial["validation_status"]["id"])
        setComments(dataTrial["comments"])
        setKeywords(dataTrial["keywords"])
        setSelectedProduct(dataTrial["product"]["id"])
        setOldReference(dataTrial["reference"])
        setOldSelectedTarget(dataTrial["target"]["id"])
        setOldSelectedTreatmentType(dataTrial["treatment_type"]["id"])
        setOldYear(dataTrial["year"])
        setOldSelectedMonth(dataTrial["month"]["id"])
        setOldSelectedProduct(dataTrial["product"]["id"])
    }

    async function retrieveVersions() {
        // Token
        const token = "Bearer " + authToken
        // Versions
        if(Number(selectedProduct) !== 0)
        {
            const resVersion = await fetch(path + "/api/eq-prve/?product_id=" + selectedProduct, 
                {
                    method: 'GET',
                    credentials: 'include',
                    mode: 'cors',
                    headers: {
                        accept: 'application/json',
                        Authorization: token,
                    },
                }
            );
            const dataVersion = await resVersion.json();
            setVersions(dataVersion["results"])
        } 
    }


    // Define useEffect hooks
    useEffect(() => {
        if(authStatus === 200)
        {
            setDataLoading(true)
            retrieveData()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(Number(selectedProduct) !== 0)
        {
            retrieveVersions()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedProduct])

    useEffect(() => {
        if(versions.length !== 0 && oldTrial !== null)
        {
            var oldVersionId = (versions.find(version => version.name === oldTrial["product_version"] && version.product.id === oldTrial["product"]["id"]))["id"]
            setSelectedVersion(oldVersionId)
            setOldSelectedVersion(oldVersionId)
            // Dataloading
            setDataLoading(false)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [versions, oldTrial])

    useEffect(() => {
        var typeName = ''
        var targetName = ''
        var monthName = ''
        if(treatmentTypes.length !== 0 && Number(selectedTreatmentType) > 0)
        {
            typeName = (treatmentTypes.find((type) => type['id'] === Number(selectedTreatmentType)))['abbreviation']
        }
        if(targets.length !== 0 && Number(selectedTarget) > 0)
        {
            targetName = (targets.find((target) => target['id'] === Number(selectedTarget)))['name']
        }
        if(months.length !== 0 && Number(selectedMonth) > 0)
        {
            monthName = (months.find((month) => month['id'] === Number(selectedMonth)))['name']
        }
        setName(typeName + ' ' + targetName + ' ' + monthName+year + ' ' + reference)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTreatmentType, selectedTarget, year, selectedMonth, reference])
    
    useEffect(() => {
        if(formSubmit === true 
            && (nameError === false) 
            && (referenceError === false) 
            && (targetError === false) 
            && (treatmentTypeError === false) 
            && (nbRecurrenceError === false) 
            && (yearError === false) 
            && (monthError === false)
            && (productError === false)
            && (versionError === false))
        {
            sendData(name, reference, selectedTarget, selectedTreatmentType, nbRecurrence, note, year, selectedMonth, selectedValstatus, comments, keywords, selectedProduct, versions.find(version => version.id === Number(selectedVersion))['name'])
        }else {
            setSkipPrompt(false);
            setFormSubmit(false)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formSubmit])

    useEffect(() => {
        if(statusNewTrial === 200) {
            const treatment_path = '/trials/' + id
            navigate(treatment_path)
        } else {
            const treatment_path = '/trials/' + id + "/edit"
            navigate(treatment_path)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusNewTrial, navigate]);

    useEffect(() => {
        // Bloquer la fermeture d'onglet/rafraîchissement
        const handleBeforeUnload = (e) => {
            if (shouldBlock === true) {
                // Standard pour afficher une confirmation (les navigateurs modernes gèrent le message)
                e.preventDefault();
                e.returnValue = "";
                // Certains navigateurs nécessitent cette ligne pour afficher la confirmation
                return (e.returnValue = "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées.");
            }
        }; 

        window.addEventListener("beforeunload", handleBeforeUnload);

        // Nettoyer l'écouteur quand le composant est démonté
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldBlock]);

    useEffect(() => {
        if (blocker.state === "blocked") {
            const confirmed = window.confirm(
                "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées."
            );

            if (confirmed) {
                blocker.proceed();
            } else {
                blocker.reset();
            }
        }
    }, [blocker]);


    // Render component
    return (
        <div>
            <TabRD tabNumber={2}/>
            <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
                <Container>
                    {isDataLoading ? (
                        <p>Chargement des données</p>
                    ) : (
                        oldTrial ? (
                            <div>
                                <h1>Modifier l'essai: {oldTrial["name"]}</h1>
                                {/*Lien de retour*/}
                                <div className='flex-row justify-start margin-left margin-bottom margin-top'>
                                    <div className='link-border'>
                                        <BackPage path={'/trials/' + id}>Retour au détail de l'essai</BackPage>
                                    </div>
                                </div>
                                <div>
                                    {(statusNewTrial !== null && statusNewTrial !== 200 && nameError === false && referenceError === false  && targetError === false && treatmentTypeError === false && nbRecurrenceError === false && yearError === false && monthError === false) ? (
                                        <p className='form-error'>L'essai existe déjà !</p>
                                    ) : (
                                        <p></p>
                                    )}
                                </div>
                                <form onSubmit={handleSubmit} className='flex-column'>
                                    <div className='flex-column form-center'>
                                        <InputForm error={nameError} type="text" label="Nom" value={name} setValue={setName} disabled={true}/>
                                        <SelectForm error={treatmentTypeError} labelText='Type de traitement' choices={treatmentTypes.sort((a, b) => (a.name > b.name)?1:-1)} selectedItem={selectedTreatmentType} setSelectedItem={setSelectedTreatmentType}/>
                                        <SelectForm error={targetError} labelText='Cibles' choices={targets.sort((a, b) => (a.name > b.name)?1:-1)} selectedItem={selectedTarget} setSelectedItem={setSelectedTarget}/>
                                        <InputForm error={yearError} type="text" label="Année" value={year} setValue={setYear} disabled={false}/>
                                        <SelectForm error={monthError} labelText='Mois' choices={months} selectedItem={selectedMonth} setSelectedItem={setSelectedMonth}/>
                                        <InputForm error={referenceError} type="text" label="Réference" value={reference} setValue={setReference} disabled={false}/>
                                        <SelectForm error={productError} labelText='Produit' choices={products.sort((a, b) => (a.name > b.name)?1:-1)} selectedItem={selectedProduct} setSelectedItem={setSelectedProduct}/>
                                        <SelectForm error={versionError} labelText='Version du produit' choices={versions} selectedItem={selectedVersion} setSelectedItem={setSelectedVersion}/>            
                                    </div>
                                    <div className='flex-column form-right'>
                                        <button type="submit" className='button'>Valider</button>
                                    </div>
                                </form> 
                            </div>
                        ) : (
                            <div>
                                <p>Essai non disponible {statusOldTrial} !</p>
                                {/*Lien de retour*/}
                                <div className='flex-row justify-start margin-left margin-bottom margin-top'>
                                    <div className='link-border'>
                                        <BackPage path={'/trials/' + id}>Retour au détail de l'essai</BackPage>
                                    </div>
                                </div>
                            </div>
                        )
                    )}
                </Container>
            </div>
        </div>
    );
}

export default TrialEdit;
